import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import UserTable from '../../../Setup/components/UserTable/UserTable';
import {
  fetchOrganizationUsers,
} from '../../../Setup/SetupActions';

class UserRoleListModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      containerWidth: 0,
      users: [],
      loading: false,
      errors: null,
      currentWelcomeUser: null,
    };
    this.onWindowResize = this.onWindowResize.bind(this);
    this.close = this.close.bind(this);
    this.syncUsers = this.syncUsers.bind(this);
  }

  onWindowResize() {
    if (this.container) {
      this.setState({ containerWidth: this.container.offsetWidth });
    }
  }

  syncUsers(params) {
    const organizationId = this.props.organization._id;
    /*
    const currentFilter = params.filter || `{}`;
    let filter = {};
    try {
      filter = JSON.parse(currentFilter);
    } catch (e) {
      filter = {};
    }
    filter.organization_role = { $and: [{ type: 'contains', filter: this.props.role }] };
    params.filter = JSON.stringify(filter);
    */
    if (!params.organizationRole) {
      delete params.organizationRole;
    }
    return this.props.dispatch(fetchOrganizationUsers(organizationId, params));
  }

  close() {
    this.props.onHide();
  }

  render() {
    const { selectedIds } = this.state;
    const { organization, show, role, connected, license } = this.props;
    return (
      <Modal show={show} onHide={this.close} bsSize='lg'>
        <Modal.Header closeButton>
          <Modal.Title>
            {organization.display_name} - {role || 'connected'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserTable
            selectedIds={selectedIds}
            hideActionColumn={true}
            toggleSelect={this.handleToggleSelect}
            fetchAction={this.syncUsers}
            organization={organization}
            showOrganizationDetailColumn={false}
            disableShowFullScreenMode
            height={400}
            canAddUser={false}
            filter={{ organizationRole: this.props.role, connected }}
            statusFilter={connected}
            licenseFilter={license}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle='default'
            onClick={this.close}
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

UserRoleListModal.propTypes = {
  organization: PropTypes.shape({
    _id: PropTypes.string,
    display_name: PropTypes.string,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  role: PropTypes.string,
  connected: PropTypes.bool,
  license: PropTypes.bool,
  users: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
UserRoleListModal.defaultProps = {
  show: false,
  role: null,
  connected: null,
  license: null,
};

function mapStateToProps() {
  return {};
}
export default connect(mapStateToProps)(UserRoleListModal);
